<template>
  <svg 
    width="19" 
    height="19" 
    viewBox="0 0 19 19"
    fill="none"
    version="1.1"
    id="svg201"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg">
  > 
    <!-- Circle Background -->
    <circle cx="9.5" cy="9.5" r="9.5" fill="#153252"/>
    
    <!-- Dynamic Number (Centered) -->
    <text 
      x="50%" 
      y="55%" 
      dominant-baseline="middle" 
      text-anchor="middle"
      fill="white" 
      font-size="9" 
      font-family="Arial, sans-serif" 
      font-weight="bold"
    >
      +{{ props.count }}
    </text>
  </svg>
</template>

<script setup lang="ts">

interface Props {
  count: number;
}

const props = defineProps<Props>();
</script>
